var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFactorAutenticacion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.256,
    height: 35.223,
    viewBox: "0 0 32.256 35.223",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_2do_factorAutenticacion",
    "data-name": "2do factorAutenticacion",
    transform: "translate(-785.018 -619.08)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19209",
    "data-name": "Trazado 19209",
    d: "M798.955,643.172l-.262-14.452a2.359,2.359,0,0,1,2.367-2.368h0a2.406,2.406,0,0,1,2.368,2.368l.244,6.636a2.364,2.364,0,0,1,1.7-.729h0a2.365,2.365,0,0,0,4.261,1.042h0a2.366,2.366,0,0,0,4.262,1.041h0a2.328,2.328,0,0,1,2.368,2.368l-.51,8.548c-.2,6.045-13.752,7.681-17.022,2.6l-6.472-8.041a2.055,2.055,0,0,1,.7-2.914c1.216.017,2.938.2,3.7,1.119l2.3,2.783Z",
    fill: "none",
    stroke: "#0f265c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19210",
    "data-name": "Trazado 19210",
    d: "M786.867,620.08h1.7a.851.851,0,0,1,.849.849v1.7a.851.851,0,0,1-.849.849h-1.7a.851.851,0,0,1-.849-.849v-1.7a.851.851,0,0,1,.849-.849Z",
    fill: "none",
    stroke: "#0f265c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19211",
    "data-name": "Trazado 19211",
    d: "M786.867,626.505h1.7a.852.852,0,0,1,.849.849v1.7a.851.851,0,0,1-.849.849h-1.7a.851.851,0,0,1-.849-.849v-1.7a.852.852,0,0,1,.849-.849Z",
    fill: "none",
    stroke: "#0f265c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19212",
    "data-name": "Trazado 19212",
    d: "M786.867,632.931h1.7a.851.851,0,0,1,.849.849v1.7a.851.851,0,0,1-.849.849h-1.7a.851.851,0,0,1-.849-.849v-1.7a.851.851,0,0,1,.849-.849Z",
    fill: "none",
    stroke: "#0f265c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19213",
    "data-name": "Trazado 19213",
    d: "M793.292,620.08h1.7a.852.852,0,0,1,.85.849v1.7a.852.852,0,0,1-.85.849h-1.7a.851.851,0,0,1-.849-.849v-1.7a.851.851,0,0,1,.849-.849Z",
    fill: "none",
    stroke: "#0f265c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19214",
    "data-name": "Trazado 19214",
    d: "M793.292,626.505h1.7a.853.853,0,0,1,.85.849v1.7a.852.852,0,0,1-.85.849h-1.7a.851.851,0,0,1-.849-.849v-1.7a.852.852,0,0,1,.849-.849Z",
    fill: "none",
    stroke: "#0f265c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19215",
    "data-name": "Trazado 19215",
    d: "M793.292,632.931h1.7a.852.852,0,0,1,.85.849v1.7a.852.852,0,0,1-.85.849h-1.7a.851.851,0,0,1-.849-.849v-1.7a.851.851,0,0,1,.849-.849Z",
    fill: "none",
    stroke: "#0f265c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19216",
    "data-name": "Trazado 19216",
    d: "M799.718,620.08h1.7a.852.852,0,0,1,.85.849v1.7a.852.852,0,0,1-.85.849h-1.7a.852.852,0,0,1-.85-.849v-1.7a.852.852,0,0,1,.85-.849Z",
    fill: "none",
    stroke: "#0f265c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFactorAutenticacion);
export default __webpack_public_path__ + "static/media/factorAutenticacion.993769451c370be12b9a388dfbbec847.svg";
export { ForwardRef as ReactComponent };